var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vfc-day vfc-week-number",style:({ borderRightColor: _vm.borderColor })},[_c('span',{staticClass:"vfc-span-day"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }